import { baseUrlFeedback } from '@/constants'
import { AnswerPayload, NPSProps, Res } from '@/types'

import base from './base'

export const npsApi = base.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    getFormDetails: builder.query<
      NPSProps,
      {
        id: string
        cpf: string
        name?: string
        email?: string
        coduser: string
      }
    >({
      query: ({ id, ...credentials }) => ({
        url: `${baseUrlFeedback}/nps/${id}`,
        params: { ...credentials },
      }),
      transformResponse: (res: Res<NPSProps>) => res.data,
    }),
    answerForm: builder.mutation<void, AnswerPayload>({
      query: (body) => ({
        url: `${baseUrlFeedback}/answers`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Home'],
    }),
  }),
})

export const { useLazyGetFormDetailsQuery, useAnswerFormMutation } = npsApi
